import { COLOR, float, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

// TA-Lib's own default length is 5; 20 is what TradingView ships.
const def: IndicatorDef = {
  id: 'STDDEV',
  version: 1,
  label: 'Standard Deviation',
  pane: 'sub',
  category: 'statistics',
  series: 'price',
  order: 10,
  inputs: [period('timeperiod', 20), float('nbdev', 1, 'Deviations', 0, 100, 0.1)],
  outputs: [line('stddev', 'StdDev', COLOR.blue)],
  talib: { functions: ['STDDEV'], expr: 'STDDEV(close, timeperiod={timeperiod}, nbdev={nbdev})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
